// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AIAi","comment":"styles_comment__1naM9"};